export interface AssignorGuarantors {
  id?: number;
  nome: string;
  email: string;
  tipoPessoa: string;
  cpfCnpj: string;
}
